import { IPassengerWalletHistory } from "models/passengerWallet";

export default function AlterBy(_: any, value: IPassengerWalletHistory) {
  if (value.trip) {
    return (
      <div className="flex flex-col gap-1">
        <p>By Trip</p>
        <div className="text-gray-500 text-xs flex flex-col gap-y-1">
          <div className="flex flex-row gap-x-2 items-center">
            <div className="max-w-3 w-full h-3 rounded-full bg-black flex items-center justify-center">
              <p className="max-w-1.5 w-full h-1.5 rounded-full bg-white"></p>
            </div>
            {value.trip?.pickup_address}
          </div>
          <div className="flex flex-row gap-x-2 items-center">
            <div className="max-w-3 w-full h-3 rounded-full bg-yellow-400 flex items-center justify-center">
              <p className="max-w-1.5 w-full h-1.5 rounded-full bg-black"></p>
            </div>
            {value.trip?.drop_off_address}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
        <p className="font-medium text-black">
          {value.reason}
        </p>
      {value.admin && (
        <p className="text-gray-500 text-xs text-start">
          Processed by {value.admin.first_name} {value.admin.last_name}
        </p>
      )}
    </div>
  );
}
